import React from 'react'
import { StyledText } from './styles'

const ValidationText = ({ children }) => <StyledText>{children}</StyledText>

export default ValidationText
